// Kalkyle for pristilbud, regnet som deler i WorkshopDetails (features/invoice/fakturaGrunnlag.js):
// rabatt på linjesummen (antall × pris), i kr eller %; dekningsbidrag = salg eks. 25 % mva minus
// kostpris (eks. mva) × antall; linjer uten kostpris er ikke med i dekningsbidraget.
// Tilbudslinjene har egne feltnavn (pris, antall, rabatt, rabattKr), så de gjøres om til
// delelinjer først. Serveren regner totalene på samme måte (rensProdukter i routes/offers.js).
import { linjesum, delelinjeBidrag, delerBidrag } from '../features/invoice/fakturaGrunnlag';

const tall = (v) => {
  const n = Number(String(v ?? '').replace(',', '.'));
  return Number.isFinite(n) ? n : 0;
};

export const harKostpris = (l) => l.kostpris !== null && l.kostpris !== undefined && l.kostpris !== '';

export const tilDelelinje = (l) => ({
  price: tall(l.pris),
  qty: Math.max(1, Math.round(tall(l.antall) || 1)),
  discount: tall(l.rabattKr),
  discountPercent: tall(l.rabatt),
  kostpris: harKostpris(l) ? tall(l.kostpris) : null,
});

export function linjeTall(l) {
  const del = tilDelelinje(l);
  const subtotal = del.price * del.qty;
  const total = linjesum(del);
  return { subtotal, total, rabattKr: subtotal - total, bidrag: delelinjeBidrag(del) };
}

// Ny rabatt i % eller kr; den andre regnes ut (som recomputeDiscountPair i WorkshopDetails).
export function medRabatt(l, modus, verdi) {
  const del = tilDelelinje(l);
  const subtotal = del.price * del.qty;
  const v = Math.max(0, tall(verdi));
  if (modus === 'kr') {
    const kr = Math.min(v, subtotal);
    return { ...l, rabattKr: kr, rabatt: subtotal > 0 ? Math.round((kr / subtotal) * 1000) / 10 : 0 };
  }
  const prosent = Math.min(100, v);
  return { ...l, rabatt: prosent, rabattKr: subtotal > 0 ? Math.round((subtotal * prosent) / 100) : 0 };
}

// Når pris eller antall endres, beholdes rabatten i % (kr regnes på nytt).
export const regnPaNytt = (l) => medRabatt(l, 'prosent', l.rabatt);

export function oppsummering(linjer) {
  const deler = linjer.map(tilDelelinje);
  const subtotal = deler.reduce((s, d) => s + d.price * d.qty, 0);
  const total = deler.reduce((s, d) => s + linjesum(d), 0);
  const db = delerBidrag(deler);
  return {
    total,
    rabattKr: subtotal - total,
    rabattProsent: subtotal > 0 ? ((subtotal - total) / subtotal) * 100 : 0,
    bidrag: db.bidrag,
    dg: db.dg,
    medKostpris: db.medKostpris,
    manglerKostpris: db.manglerKostpris,
  };
}

export const kr = (n) => `${new Intl.NumberFormat('nb-NO', { maximumFractionDigits: 0 }).format(Math.round(Number(n) || 0))} kr`;
export const prosent = (n) => `${new Intl.NumberFormat('nb-NO', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(Number(n) || 0)} %`;

export const STATUS = {
  utkast: { navn: 'Utkast', farge: 'bg-slate-100 text-slate-800' },
  sendt: { navn: 'Sendt', farge: 'bg-sky-100 text-sky-900' },
  godkjent: { navn: 'Godkjent', farge: 'bg-emerald-100 text-emerald-900' },
  avslatt: { navn: 'Avslått', farge: 'bg-red-100 text-red-900' },
  kansellert: { navn: 'Trukket tilbake', farge: 'bg-slate-200 text-slate-800' },
  // En ny versjon har overtatt (Offer.erstattetAv, src/lib/tilbudStatus.js).
  erstattet: { navn: 'Erstattet', farge: 'bg-slate-200 text-slate-800' },
};
export const statusFor = (s) => STATUS[s] || STATUS.utkast;
